'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_presto$002etypes$0024$002dUser$002dId$0024$0024anon$0024136 from "./presto.types$-User-Id$$anon$136.js";
var $p;
/** @constructor */
function $c_Lpresto_types$UserId$() {
  this.cdx = null;
  this.cdy = false;
  this.cdv = null;
  this.cdw = false;
  this.cdz = null;
  this.cdA = false;
  this.cdB = null;
  this.cdC = false;
}
export { $c_Lpresto_types$UserId$ as $c_Lpresto_types$UserId$ };
$p = $c_Lpresto_types$UserId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_O();
$p.constructor = $c_Lpresto_types$UserId$;
/** @constructor */
function $h_Lpresto_types$UserId$() {
}
export { $h_Lpresto_types$UserId$ as $h_Lpresto_types$UserId$ };
$h_Lpresto_types$UserId$.prototype = $p;
$p.adD = (function() {
  if ((!this.cdy)) {
    this.cdx = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Encoder$().j0;
    this.cdy = true;
  }
  return this.cdx;
});
$p.jU = (function() {
  if ((!this.cdw)) {
    this.cdv = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lio_circe_Decoder$().dZ;
    this.cdw = true;
  }
  return this.cdv;
});
$p.cIX = (function() {
  if ((!this.cdA)) {
    this.cdz = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lcom_raquo_laminar_modifiers_RenderableText$$anon$1(new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sjsr_AnonFunction1(((_$31) => {
      var t = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$uJ(_$31);
      return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_RTLong$().hQ(t.e, t.f);
    })), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lcom_raquo_laminar_modifiers_RenderableText$());
    this.cdA = true;
  }
  return this.cdz;
});
$p.SX = (function() {
  if ((!this.cdC)) {
    this.cdB = new $j_presto$002etypes$0024$002dUser$002dId$0024$0024anon$0024136.$c_Lpresto_types$UserId$$anon$136(this);
    this.cdC = true;
  }
  return this.cdB;
});
var $d_Lpresto_types$UserId$ = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$TypeData().i($c_Lpresto_types$UserId$, "presto.types$UserId$", ({
  a2E: 1,
  D: 1
}));
export { $d_Lpresto_types$UserId$ as $d_Lpresto_types$UserId$ };
var $n_Lpresto_types$UserId$;
function $m_Lpresto_types$UserId$() {
  if ((!$n_Lpresto_types$UserId$)) {
    $n_Lpresto_types$UserId$ = new $c_Lpresto_types$UserId$();
  }
  return $n_Lpresto_types$UserId$;
}
export { $m_Lpresto_types$UserId$ as $m_Lpresto_types$UserId$ };
//# sourceMappingURL=presto.types$-User-Id$.js.map
